import { GitLayout } from "@/components/organisms/git/GitLayout";

export function GitPage() {
  return (
    <div className="flex h-full flex-col">
      <GitLayout />
    </div>
  );
}

export default GitPage;
